<template>
  <div class="tw-min-h-[calc(100vh-146px)] tw-bg-bgPage">
    <BaseTopLine> </BaseTopLine>

    <div
      class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px]"
      ref="topFilter"
    >
      <div
        class="tw-flex tw-items-end tw-gap-[20px] tw-text-white tw-max-w-[1800px]"
      >
        <div class="tw-app-input-container">
          <label class="tw-app-input-container-label">
            {{ dataLang["reg_company_1"] }}
          </label>
          <BaseInputNew
            inputClass="tw-app-input-dark"
            @keyupEnter="loadData(1)"
            placeholder=""
            @input="(data) => fillFilter({ ...data })"
            inputName="companies__id"
            value=""
            nameSign=""
          />
        </div>

        <div class="tw-app-input-container">
          <label class="tw-app-input-container-label"> Реферер </label>
          <BaseInputNew
            inputClass="tw-app-input-dark"
            @keyupEnter="loadData(1)"
            placeholder=""
            @input="(data) => fillFilter({ ...data })"
            inputName="companies__referer_id"
            value=""
            nameSign=""
          />
        </div>

        <div class="tw-app-input-container">
          <label class="tw-app-input-container-label">
            {{ dataLang["reg_company_2"] }}
          </label>
          <BaseInputNew
            inputClass="tw-app-input-dark"
            @keyupEnter="loadData(1)"
            placeholder=""
            @input="(data) => fillFilter({ ...data, type: 'like' })"
            inputName="companies__name"
            value=""
            nameSign=""
          />
        </div>

        <div class="tw-app-input-container">
          <label class="tw-app-input-container-label"> Email </label>
          <BaseInputNew
            inputClass="tw-app-input-dark"
            @keyupEnter="loadData(1)"
            placeholder=""
            @input="(data) => fillFilter({ ...data, type: 'like' })"
            inputName="company_settings__set_req_email"
            value=""
            nameSign=""
          />
        </div>

        <div class="tw-app-input-container">
          <label class="tw-app-input-container-label">
            {{ dataLang["reg_company_3"] }}
          </label>
          <BaseInputNew
            inputClass="tw-app-input-dark"
            @keyupEnter="loadData(1)"
            placeholder=""
            @input="(data) => fillFilter({ ...data, type: 'like' })"
            inputName="company_settings__set_req_inn"
            value=""
            nameSign=""
          />
        </div>

        <div class="tw-app-input-container multiselect-type-1">
          <label class="tw-app-input-container-label">
            {{ dataLang["reg_company_60"] }}
          </label>
          <BaseSelect
            placeholder=""
            selectLabel=""
            deselectLabel=""
            minHeight="300"
            openDirection="bottom"
            @input="
              (data) =>
                fillFilter({
                  name: 'cities__id',
                  value: data.cities__id,
                })
            "
            v-model="selectsFilter.city"
            :options="selectsData.city"
            label="cities__name"
          >
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template
            ><template slot="selectedLabel">{{
              dataLang["select_selected"]
            }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>
        </div>

        <div class="tw-app-input-container multiselect-type-1">
          <label class="tw-app-input-container-label">
            {{ dataLang["reg_company_5"] }}
          </label>
          <BaseSelect
            placeholder=""
            selectLabel=""
            deselectLabel=""
            minHeight="300"
            openDirection="bottom"
            @input="
              (data) =>
                fillFilter({
                  name: 'companies__status',
                  value: data.value,
                  type: data?.type,
                })
            "
            v-model="selectsFilter.accepts"
            :options="selectsData.accepts"
            label="label"
          >
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template
            ><template slot="selectedLabel">{{
              dataLang["select_selected"]
            }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>
        </div>

        <div class="tw-app-input-container multiselect-type-1">
          <label class="tw-app-input-container-label">
            {{ dataLang["reg_company_21"] }}
          </label>
          <BaseSelect
            placeholder=""
            selectLabel=""
            deselectLabel=""
            minHeight="300"
            openDirection="bottom"
            @input="
              (data) =>
                fillFilter({
                  name: 'companies__balance',
                  value: data.value,
                  operator: data?.operator,
                  type: data?.type,
                })
            "
            v-model="selectsFilter.balance"
            :options="selectsData.balance"
            label="label"
          >
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template
            ><template slot="selectedLabel">{{
              dataLang["select_selected"]
            }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>
        </div>

        <div class="tw-flex tw-flex-row">
          <button @click="loadData(1)" type="button" class="tw-app-btn-primary">
            {{ dataLang["reg_fin_text_4"] }}
          </button>
          <button @click="resetFilter" type="button" class="tw-app-btn-light">
            {{ dataLang["reg_fin_text_5"] }}
          </button>
        </div>
      </div>
    </div>

    <div class="tw-px-[26px] tw-mt-[15px]">
      <div class="tw-flex tw-justify-between">
        <div class="tw-flex tw-gap-[10px]">
          <button
            @click="
              () => {
                nextModalFromPin = 'addBalanceFirstStepModal';
                $modal.show('pincode', { modal: 'addBalanceFirstStepModal' });
              }
            "
            class="tw-app-btn-primary-outline tw-app-btn-lock"
          >
            {{ dataLang["reg_company_45"] }}
          </button>
          <button
            consumptionBalanceFirstStepModal
            @click="
              () => {
                nextModalFromPin = 'consumptionBalanceFirstStepModal';
                $modal.show('pincode', {
                  modal: 'consumptionBalanceFirstStepModal',
                });
              }
            "
            class="tw-app-btn-primary-outline tw-app-btn-lock"
          >
            {{ dataLang["reg_company_25"] }}
          </button>
        </div>

        <div class="tw-flex tw-gap-[10px]">
          <button
            @click="
              () => {
                activeSelectRowsMultiple.length
                  ? $modal.show('addReferrer')
                  : $toast.error(dataLang['reestr_objects_archive_text15']);
              }
            "
            class="tw-app-btn-primary-outline"
          >
            Прикрепить реф.
          </button>

          <button
            @click="
              () => {
                activeSelectRowsMultiple.length
                  ? $modal.show('removeReferrer')
                  : $toast.error(dataLang['reestr_objects_archive_text15']);
              }
            "
            class="tw-app-btn-primary-outline"
          >
            Открепить реф.
          </button>

          <button
            @click="
              () => {
                nextModalFromPin = 'exel';
                activeSelectRowsMultiple.length
                  ? $modal.show('pincode', { modal: 'delete' })
                  : $toast.error(dataLang['reestr_objects_archive_text15']);
              }
            "
            class="tw-app-btn-primary-outline tw-app-btn-lock"
          >
            <img
              :src="require(`@/assets/icons/minus-dark.svg`)"
              width="13.5"
              height="13.5"
              class="tw-my-[-5px]"
            />
            {{ dataLang["reg_fin_text_37"] }}
          </button>

          <button
            @click="
              () => {
                nextModalFromPin = 'exel';
                $modal.show('pincode', { modal: 'exel' });
              }
            "
            class="tw-app-btn-primary-outline tw-app-btn-lock"
          >
            <img
              :src="require(`@/assets/icons/to-exel.svg`)"
              width="13.5"
              height="13.5"
              class="tw-my-[-5px]"
            />
            {{ dataLang["reg_fin_text_38"] }}
          </button>

          <button
            @click="
              () => {
                nextModalFromPin = 'sendNotificationModal';
                $modal.show('pincode', { modal: 'sendNotificationModal' });
              }
            "
            class="tw-app-btn-primary-outline tw-app-btn-lock"
          >
            {{ dataLang["reg_company_13"] }}
          </button>
        </div>
      </div>

      <div class="tw-my-[15px] tw-flex tw-justify-end">
        <TwBasePagination
          :page-count="numPages"
          :pagination-params="{
            ...paginationFinesStateParams,
            limit: limitPaginationValue,
          }"
          :showLimitInput="true"
          @updateLimitValue="updateLimitValue"
          :page-range="10"
          :margin-pages="0"
          :click-handler="loadData"
        >
        </TwBasePagination>
      </div>

      <div class="tw-relative tw-mt-[15px]" style="min-height: 400px">
        <BaseLoader v-if="localLoading"></BaseLoader>
        <ve-table
          class="rest-style-table fixed-header"
          style="width: 100%"
          :columns="columns"
          :table-data="dataTable"
          :border-x="true"
          :border-y="true"
          row-key-field-name="companies__id"
          ref="mainTable"
          :sort-option="sortOption"
          :eventCustomOption="eventCustomOption"
          v-if="!localLoading"
          :cell-style-option="cellStyleOption"
          :checkbox-option="{
            selectedRowChange: selectedRowChange,
            selectedAllChange: selectedAllChange,
            hideSelectAll: false,
          }"
          :clickHighlight="false"
          :rowStyleOption="{
            hoverHighlight: true,
          }"
          :cellSelectionOption="{ enable: false }"
        >
        </ve-table>
      </div>
    </div>

    <BaseModal
      name="pincode"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      @beforeOpen="({ params }) => (nextModalFromPin = params?.modal)"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('pincode')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title">Внимание!</div>
          <div class="tw-my-[15px]">Введите пароль администратора!</div>

          <BaseInputNew
            inputClass="tw-app-input-type-3"
            :input-name="'pincode'"
            @input="(data) => (pincode = data.value)"
          >
          </BaseInputNew>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('pincode')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["vehile_modal_btn_reset"] }}
            </button>
            <button
              @click="() => (pincode ? acceptNext() : '')"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["tracker_text51"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="addReferrer"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('addReferrer')"
        ></button>
        <div>
          <div class="tw-app-modal__title">Прикрепить реферера</div>
          <BaseSelect
            class="multiselect-type-3"
            style="z-index: 2"
            @input="
              (data) => updateValue({ name: 'refererId', value: data.value })
            "
            placeholder=""
            selectLabel=""
            deselectLabel=""
            v-model="selectsDataForModal.companies"
            :custom-label="({ label, value }) => `${label} (${value})`"
            :options="selectsData.companies"
            :maxHeight="115"
            openDirection="bottom"
          >
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template>
            <template slot="selectedLabel">{{
              dataLang["select_selected"]
            }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('addReferrer')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              Отмена
            </button>
            <button
              @click="onAddReferrer"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              Прикрепить
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="removeReferrer"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('removeReferrer')"
        ></button>
        <div>
          <div class="tw-app-modal__title">Точно открепить реферера?</div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('removeReferrer')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              Отмена
            </button>
            <button
              @click="onRemoveReferrer"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              Открепить
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <SendNotificationModal />
    <AddBalanceFirstStepModal />
    <AddBalanceSecondStepModal />
    <DoneAddModal />
    <ConsumptionBalanceFirstStepModal />
    <DoneСonsumptionModal />
    <ConsumptionBalanceSecondStepModal />
    <CompaniesModal />
    <ConsumptionBalanceTreeStepModal />
    <ConsumptionBalanceFourStepModal />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import GeneralService from "@/api/GeneralService";
import httpInstance from "@/http-common";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
import SendNotificationModal from "./companies-modal/SendNotificationModal.vue";
import DoneAddModal from "./companies-modal/DoneAddModal.vue";
import DoneСonsumptionModal from "./companies-modal/DoneСonsumptionModal.vue";
import AddBalanceFirstStepModal from "./companies-modal/add-balance/AddBalanceFirstStepModal.vue";
import ConsumptionBalanceFirstStepModal from "./companies-modal/consumption-balance/ConsumptionBalanceFirstStepModal.vue";
import ConsumptionBalanceSecondStepModal from "./companies-modal/consumption-balance/ConsumptionBalanceSecondStepModal.vue";
import AddBalanceSecondStepModal from "./companies-modal/add-balance/AddBalanceSecondStepModal.vue";
import ConsumptionBalanceTreeStepModal from "./companies-modal/consumption-balance/ConsumptionBalanceTreeStepModal.vue";
import ConsumptionBalanceFourStepModal from "./companies-modal/consumption-balance/ConsumptionBalanceFourStepModal.vue";

import CompaniesModal from "./companies-modal/CompaniesModal.vue";
import EventBus from "@/event-bus";

export default {
  components: {
    VeTable,
    VueTabs,
    VTab,
    SendNotificationModal,
    CompaniesModal,
    DoneAddModal,
    ConsumptionBalanceFirstStepModal,
    DoneСonsumptionModal,
    AddBalanceFirstStepModal,
    AddBalanceSecondStepModal,
    ConsumptionBalanceSecondStepModal,
    ConsumptionBalanceTreeStepModal,
    ConsumptionBalanceFourStepModal,
  },

  data() {
    return {
      limitPaginationValue: 50,
      companiesStatistics: {},
      typePin: "",
      localLoading: true,
      dataTable: [],
      activeSelectRowsMultiple: [],
      filter: [],
      updatedValues: {},
      activePagePagination: {},
      pincode: "",
      dataForModal: {},
      selectsDataForModal: {
        companies: [],
      },
      selectsFromModal: {},
      nextModalFromPin: "",
      selectsData: {
        city: [],
        accepts: [],
        balance: [],
        companies: [],
      },
      selectsFilter: {
        city: [],
        accepts: [],
        balance: [],
      },
      sortOption: {
        sortChange: (params) => {
          this.sortChange(params);
        },
      },
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              console.log(row);
              this.$modal.show("companiesModal", {
                id: row.companies__id,
                data: row,
              });
            },
          };
        },
      },

      //       {
      //     "companies__status": "cell-status-red"
      // }
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          if (column.field == "companies__status") {
            return row?.config?.companies__status;
          }
          if (column.field == "companies__last_activity_at") {
            return row?.config?.companies__last_activity_at;
          }
          if (column.field == "companies__balance") {
            return row?.config?.companies__balance;
          }
        },
      },
    };
  },
  methods: {
    onRemoveReferrer() {
      GeneralService.delete(
        `/super/companies/referer/delete/${this.activeSelectRowsMultiple}`
      )
        .then((data) => {
          this.loadData();
          this.$toast.success(data.data.message);
        })
        .catch((e) => {
          this.$toast.error(e.response.data.message);
        })
        .finally(() => {
          this.selectsDataForModal.companies = [];
          this.activeSelectRowsMultiple = [];
          this.$modal.hide("removeReferrer");
        });
    },
    onAddReferrer() {
      GeneralService.editOrCreate(
        `/super/companies/referer/add/${this.activeSelectRowsMultiple}`,
        {
          refererId: this.selectsDataForModal.companies.value,
        }
      )
        .then((data) => {
          this.loadData();
          this.$toast.success(data.data.message);
        })
        .catch((e) => {
          this.$toast.error(e.response.data.message);
        })
        .finally(() => {
          this.selectsDataForModal.companies = [];
          this.activeSelectRowsMultiple = [];
          this.$modal.hide("addReferrer");
        });
    },
    sortChange(params) {
      console.log(params);
      this.dataTable.sort((a, b) => {
        if (params.cities__id) {
          if (params.cities__id === "asc") {
            return a.cities__id - b.cities__id;
          } else if (params.cities__id === "desc") {
            return b.cities__id - a.cities__id;
          } else {
            return 0;
          }
        } else if (params.cities__name) {
          if (params.cities__name === "asc") {
            return (
              a.cities__name
                .toLowerCase()
                .localeCompare(b.cities__name.toLowerCase()) ||
              a.cities__name.localeCompare(b)
            );
          } else if (params.cities__name === "desc") {
            return (
              b.cities__name
                .toLowerCase()
                .localeCompare(a.cities__name.toLowerCase()) ||
              b.cities__name.localeCompare(a)
            );
          } else {
            return 0;
          }
        } else if (params.companies__name) {
          if (params.companies__name === "asc") {
            return (
              a.companies__name
                .toLowerCase()
                .localeCompare(b.companies__name.toLowerCase()) ||
              a.companies__name.localeCompare(b)
            );
          } else if (params.companies__name === "desc") {
            return (
              b.companies__name
                .toLowerCase()
                .localeCompare(a.companies__name.toLowerCase()) ||
              b.companies__name.localeCompare(a)
            );
          } else {
            return 0;
          }
        } else if (params.employees__name) {
          if (params.employees__name === "asc") {
            return (
              a.employees__name
                .toLowerCase()
                .localeCompare(b.employees__name.toLowerCase()) ||
              a.companies__name.localeCompare(b)
            );
          } else if (params.employees__name === "desc") {
            return (
              b.employees__name
                .toLowerCase()
                .localeCompare(a.employees__name.toLowerCase()) ||
              b.companies__name.localeCompare(a)
            );
          } else {
            return 0;
          }
        } else if (params.companies__id) {
          if (params.companies__id === "asc") {
            return a.companies__id - b.companies__id;
          } else if (params.companies__id === "desc") {
            return b.companies__id - a.companies__id;
          } else {
            return 0;
          }
        } else if (params.objects_count) {
          if (params.objects_count === "asc") {
            return a.objects_count - b.objects_count;
          } else if (params.objects_count === "desc") {
            return b.objects_count - a.objects_count;
          } else {
            return 0;
          }
        } else if (params.companies__referer_id) {
          if (params.companies__referer_id === "asc") {
            return a.companies__referer_id - b.companies__referer_id;
          } else if (params.companies__referer_id === "desc") {
            return b.companies__referer_id - a.companies__referer_id;
          } else {
            return 0;
          }
        } else if (params.companies__balance) {
          if (params.companies__balance === "asc") {
            return a.companies__balance - b.companies__balance;
          } else if (params.companies__balance === "desc") {
            return b.companies__balance - a.companies__balance;
          } else {
            return 0;
          }
        } else if (params.companies__status) {
          if (params.companies__status === "asc") {
            return a.companies__status.length - b.companies__status.length;
          } else if (params.companies__status === "desc") {
            return b.companies__status.length - a.companies__status.length;
          } else {
            return 0;
          }
        } else if (params.companies__last_activity_at) {
          if (params.companies__last_activity_at === "asc") {
            return (
              new Date(a.companies__last_activity_at) -
              new Date(b.companies__last_activity_at)
            );
          } else if (params.companies__last_activity_at === "desc") {
            return (
              new Date(b.companies__last_activity_at) -
              new Date(a.companies__last_activity_at)
            );
          } else {
            return 0;
          }
        } else if (params.companies__created_at) {
          if (params.companies__created_at === "asc") {
            return (
              new Date(a.companies__created_at) -
              new Date(b.companies__created_at)
            );
          } else if (params.companies__created_at === "desc") {
            return (
              new Date(b.companies__created_at) -
              new Date(a.companies__created_at)
            );
          } else {
            return 0;
          }
        }
      });
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },

    updateValue(data) {
      if (data.name !== "refererId") {
        this.updatedValues[data.name] = data.value;
      }
    },

    computedTranslate(values, tranaslate) {
      let keys = Object.keys(values);
      let tranaslateLocal = tranaslate;
      keys.forEach((keyName) => {
        tranaslateLocal = tranaslateLocal.replace(
          `\\${keyName}\\`,
          values[keyName]
        );
      });
      return tranaslateLocal;
    },

    acceptNext() {
      console.log(this.nextModalFromPin);
      if (this.nextModalFromPin == "delete") {
        this.$modal.show("deleteRow");
        if (this.activeSelectRowsMultiple.length) {
          this.deleteRow();
        }
      } else if (this.nextModalFromPin == "exel") {
        console.log(this.nextModalFromPin == "exel");
        this.loadExel(
          `/super/companies/table/xlsx?pincode=${this.pincode}`,
          "xlsx"
        );
      } else if (this.nextModalFromPin == "sendNotificationModal") {
        this.$modal.hide("pincode");
        this.$modal.show("sendNotificationModal", {
          type: "all",
          pincode: this.pincode,
        });
      } else if (this.nextModalFromPin == "addBalanceFirstStepModal") {
        this.$modal.hide("pincode");
        this.$modal.show("addBalanceFirstStepModal", { pincode: this.pincode });
      } else if (this.nextModalFromPin == "consumptionBalanceFirstStepModal") {
        this.$modal.hide("pincode");
        this.$modal.show("consumptionBalanceFirstStepModal", {
          pincode: this.pincode,
        });
      }
    },

    deleteRow() {
      // GeneralService.delete(
      //   `/finreestr/${this.activeSelectRowsMultiple}?pincode=${this.pincode}`
      // )
      //   .then((data) => {})
      //   .catch((e) => {
      //     this.activeSelectRowsMultiple = []
      //     this.$toast.error(e.response.data.message, {duration: 5000})
      //   })
      //   .finally(() => {
      //     this.activeSelectRowsMultiple = []
      //     this.typePin = ''
      //     this.pincode = ''
      //     this.$modal.hide('deleteRow')
      //     this.$modal.hide('pincode')
      //     this.loadData()
      //   })
      this.$modal.hide("pincode");
    },

    async loadExel(urlToFetch, ext) {
      console.log(1313);
      try {
        let dataFrom = await httpInstance.get(urlToFetch, {
          responseType: "blob",
          params: {
            ...this.paginationFinesStateParams,
            where: JSON.stringify([...this.filter]),
          },
        });
        const filename = new Date().toISOString();
        const url = window.URL.createObjectURL(dataFrom.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${filename}.${ext}`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        this.pincode = "";
        this.$modal.hide("pincode");
        this.loadData();
      } catch (e) {
        console.error(e);
      }
    },

    saveEditModal() {
      GeneralService.edit(`/trackers/${this.dataForModal.gps__id}`, {
        ...this.updatedValues,
      })
        .then((data) => {
          this.$modal.hide("editTracker");
          this.loadData();
        })
        .catch((e) => {
          this.selectsFromModal.owners = [];
          this.$toast.error(e.response.data.message, { duration: 5000 });
        });
    },

    resetFilter() {
      this.$refs.mainTable.$el
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
      this.$refs.topFilter
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
      this.filter = [];
      this.selectsFilter.city = [];
      this.selectsFilter.accepts = this.selectsData.accepts[0];
      this.selectsFilter.balance = this.selectsData.balance[0];
      this.loadData();
    },

    onCloseModal() {
      this.currentId = null;
      this.updatedValues = {};
      this.dataForModal = {};
      this.activeSelectRowsMultiple = [];
      this.selectsFromModal.objectsVehicle = [];
      this.selectsFromModal.typeVehicles = [];
    },
    deleteActionAndModal() {
      if (this.activeSelectRowsMultiple.length) {
        this.$modal.show("acceptDelete");
      } else {
        this.$modal.show("withoutOptionsModal");
      }
    },
    pincodeModalHandler() {
      this.pincode = "";
      this.activeSelectRowsMultiple = [];
    },
    computedFilterDateSelect() {
      if (
        this.selectTimeTopFilter.dateCreatedStart.length &&
        this.selectTimeTopFilter.dateCreatedEnd.length
      ) {
        return {
          field: "finreestr__created_at",
          value: [
            this.selectTimeTopFilter.dateCreatedStart
              .split(".")
              .reverse()
              .join("-"),
            this.selectTimeTopFilter.dateCreatedEnd
              .split(".")
              .reverse()
              .join("-"),
          ],
          operator: "between",
        };
      } else {
        return {
          field: "finreestr__created_at",
          value: [],
          operator: "between",
          mod: "dateUTCLastMonday",
        };
      }
    },
    updateLimitValue(data) {
      this.limitPaginationValue = data;
      this.loadData();
    },
    loadData(page = 1) {
      this.localLoading = true;
      Promise.all([
        GeneralService.get(`/cities`, { params: { limit: 10000 } })
          .then((data) => {
            this.selectsData.city = data.data.data.rows;
          })
          .catch((e) => {
            console.error(e);
          }),
        GeneralService.get(`/super/companies/referer/select/companies`, {
          params: { limit: 10000 },
        })
          .then((data) => {
            this.selectsData.companies = data.data.data.map((item) => {
              return {
                label: Object.values(item)[0],
                value: Object.keys(item)[0],
              };
            });
          })
          .catch((e) => {
            console.error(e);
          }),
      ]).then(() => {
        GeneralService.get(`/super/companies/table/main`, {
          params: {
            page: page,
            limit: this.limitPaginationValue,
            where: JSON.stringify([...this.filter]),
          },
        })
          .then((data) => {
            this.dataTable = data.data.data.rows;
            this.companiesStatistics.total = data.data.data.total;
            this.companiesStatistics.totalСompanies =
              data.data.data.totalСompanies;
            this.getFinesAll(data.data.data);
            this.localLoading = false;
          })
          .catch((e) => {
            this.$toast.error("Неизвестная ошибка при загрузке таблицы", {
              duration: 5000,
            });
          });
      });
    },
    fillFilter(data) {
      console.log(data);
      let newValueFilter =
        data.type == "like" ? `;percent;${data.value};percent;` : data.value;
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
          ...(data.operator && { operator: data.operator }),
          ...(data.mod && { mod: data.mod }),
        });
      } else {
        let indexed = this.filter.findIndex((x) => x.field == data.name);
        this.filter[indexed].value = newValueFilter;
        if (data?.operator) {
          this.filter[indexed].operator = data.operator;
        }
      }
      let indexed = this.filter.findIndex((x) => x.field == data.name);
      if (indexed !== -1) {
        this.filter[indexed].value = newValueFilter;
        if (data.type == "delete") {
          console.log(323323223);
          this.filter.splice(indexed, 1);
        }
      }
    },

    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },

    ...mapActions("finesPagination", ["getFinesAll"]),
  },
  mounted() {
    EventBus.$on("updateModalsFin", () => {
      this.loadData();
    });
    EventBus.$on("updateContentData", () => {
      this.loadData();
    });
  },
  beforeMount() {},
  created() {
    this.loadData();

    this.selectsData.accepts = [
      {
        label: "Любое",
        value: "",
        type: "delete",
      },
      {
        label: this.dataLang["company_status_not_requested"],
        value: "company_status_not_requested",
      },
      {
        label: this.dataLang["company_status_requested"],
        value: "company_status_requested",
      },
      {
        label: this.dataLang["company_status_confirmed"],
        value: "company_status_confirmed",
      },
      {
        label: this.dataLang["company_status_rejected"],
        value: "company_status_rejected",
      },
    ];
    this.selectsFilter.accepts = this.selectsData.accepts[0];

    this.selectsData.balance = [
      {
        label: this.dataLang["reg_company_105"],
        value: "0",
        type: "delete",
      },
      {
        label: this.dataLang["reg_company_106"],
        value: "0",
        operator: "<",
      },
      {
        label: this.dataLang["reg_company_107"],
        value: "0",
        operator: ">=",
      },
    ];
    this.selectsFilter.balance = this.selectsData.balance[0];
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    ...mapState("finesPagination", ["paginationFinesStateParams"]),
    ...mapGetters("finesPagination", ["numPages"]),

    columns() {
      return [
        {
          field: "",
          key: "a62",
          type: "checkbox",
          title: "",
          width: "1%",
          align: "center",
        },
        {
          field: "companies__status",
          key: "1623236",
          title: this.dataLang["reg_company_14"],
          align: "center",
          width: "10%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          sortBy: "desc",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.companies__status
                  ? this.dataLang[row.companies__status]
                  : ""}
              </span>
            );
          },
        },
        {
          field: "companies__id",
          key: "162336",
          title: this.dataLang["reg_company_15"],
          align: "center",
          width: "5%",
          sortBy: "desc",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "objects_count",
          key: "1623361",
          title: "Объектов",
          align: "center",
          sortBy: "desc",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "companies__created_at",
          key: "12861326",
          title: this.dataLang["reg_company_74"],
          align: "center",
          width: "10%",
          sortBy: "desc",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.companies__created_at
                  ? this.$time(row.companies__created_at).format(
                      `${this.userSetting.company__tempalte_date}`
                    )
                  : ""}
              </span>
            );
          },
        },
        {
          field: "companies__referer_id",
          key: "163360",
          title: this.dataLang["reg_company_111"],
          align: "center",
          width: "5%",
          sortBy: "desc",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "companies__name",
          key: "163236",
          title: this.dataLang["reg_company_2"],
          align: "start",
          width: "15%",
          sortBy: "desc",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },

        {
          field: "company_settings__set_req_inn",
          key: "136326",
          title: this.dataLang["reg_company_3"],
          align: "center",
          width: "5%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "cities__name",
          key: "162136",
          title: this.dataLang["reg_company_60"],
          align: "center",
          width: "10%",
          sortBy: "desc",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "employees__name",
          key: "172551",
          title: this.dataLang["reg_company_18"],
          align: "center",
          width: "20%",
          sortBy: "desc",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "employees__phone",
          key: "166136",
          title: this.dataLang["reg_company_19"],
          align: "center",
          width: "10%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "companies__last_activity_at",
          key: "1286136",
          title: this.dataLang["reg_company_77"],
          align: "center",
          width: "10%",
          sortBy: "desc",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.companies__last_activity_at
                  ? this.$time(row.companies__last_activity_at).format(
                      `${this.userSetting.company__tempalte_date}`
                    )
                  : ""}
              </span>
            );
          },
        },
        {
          field: "companies__status_by_rating",
          key: "124124445",
          title: "Статус",
          align: "center",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>{this.dataLang[row.companies__status_by_rating]}</span>
            );
          },
        },
        {
          field: "companies__total_rating",
          key: "companies__total_rating",
          title: "Рейтинг",
          align: "center",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <div>
                {row.companies__total_rating
                  ? row.companies__total_rating.split(".").join(",")
                  : ""}
              </div>
            );
          },
        },
        {
          field: "companies__total_score",
          key: "companies__total_score",
          title: "Баллы",
          align: "center",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <div>
                {row.companies__total_score
                  ? row.companies__total_score.split(".").join(",")
                  : ""}
              </div>
            );
          },
        },
        {
          field: "companies__balance",
          key: "12846136",
          title: this.dataLang["reg_company_57"],
          align: "center",
          width: "5%",
          sortBy: "desc",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <div>
                {row.companies__balance
                  ? row.companies__balance.split(".").join(",")
                  : ""}
              </div>
            );
          },
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.payload-button {
  display: flex;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  cursor: pointer;

  &--consumption {
    border-radius: 3px;
    box-shadow: 0px 7px 2px 0px #00000000;
    background-color: rgb(223, 222, 222);

    &:before {
      content: "";
      background-color: #ff2400;
      width: 7px;
      height: 1.5px;
      display: block;
      margin: auto;
    }
  }

  &--move {
    background-color: #0c63aa;
    border-radius: 3px;

    img {
      margin: auto;
    }
  }

  &--top {
    background-color: #8000ff;
    border-radius: 3px;

    img {
      margin: auto;
    }
  }

  &--add {
    background-color: #f6ee25;
    border-radius: 3px;

    img {
      margin: auto;
    }
  }
}

.top-line-custom {
  position: absolute;
  display: flex;
  justify-content: space-between;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: white;
  width: 65%;
}
</style>
